import { AiAgentSettingsData } from '@/features/ap_payees/components/PayeeDetailDrawer/types';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import { useMemo } from 'react';

type UseAiAgentSettingsVisibilityParams = {
  data?: AiAgentSettingsData;
};

export const useAiAgentSettingsVisibility = ({
  data,
}: UseAiAgentSettingsVisibilityParams) => {
  const isFeatureEnabled = useGetFlags('PAYEE_AI_AGENT_SETTINGS');

  const isVisible = useMemo(() => {
    if (!isFeatureEnabled) {
      return false;
    }

    const hasAiAgentSettings =
      data?.ai_agent_service_settings &&
      data.ai_agent_service_settings.length > 0;

    return hasAiAgentSettings;
  }, [isFeatureEnabled, data?.ai_agent_service_settings]);

  return {
    isVisible,
  };
};
